import { useQueries, useQuery } from "@tanstack/react-query";
import {
  getJointBillServicePeriodData,
  getOverview,
  getServiceProviderGroups,
  getServiceProviderVisibleCategories,
} from "./services";
import {
  type IJointBillServicePeriodData,
  type IJointBillServicePeriodDataRequestParams,
  type IOverview,
} from "./types";

export const useOverviewQuery = () =>
  useQuery<IOverview>({
    queryKey: ["overview"],
    queryFn: getOverview,
    staleTime: Infinity,
  });

export const useJointBillServicePeriodDataQuery = (
  requestParams: IJointBillServicePeriodDataRequestParams,
  enabled = true,
) =>
  useQuery<IJointBillServicePeriodData>({
    queryKey: [
      "jointBillServicePeriodData",
      requestParams.jointBillServiceId,
      requestParams.periodId,
    ],
    queryFn: () => getJointBillServicePeriodData(requestParams),
    staleTime: Infinity,
    enabled: enabled && requestParams.periodId != 0,
  });

export const useJointBillServicePeriodDataQueries = (
  requestParams: IJointBillServicePeriodDataRequestParams[],
) =>
  useQueries({
    queries: requestParams.map((rp) => ({
      queryKey: [
        "jointBillServicePeriodData",
        rp.jointBillServiceId,
        rp.periodId,
      ],
      queryFn: () => getJointBillServicePeriodData(rp),
      staleTime: Infinity,
      enabled: rp.periodId != 0,
    })),
  });

export const useServiceProviderGroupsQuery = (enabled = false) =>
  useQuery<string[]>({
    queryKey: ["serviceProvidersGroups"],
    queryFn: getServiceProviderGroups,
    staleTime: Infinity,
    enabled,
  });

export const useServiceProviderCategoriesQuery = (enabled = false) =>
  useQuery<string[]>({
    queryKey: ["serviceProvidersCategories"],
    queryFn: getServiceProviderVisibleCategories,
    staleTime: Infinity,
    enabled,
  });
